import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '../../../../../../apps/fuse/src/app/shared/shared.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {ExtendedModule} from '@angular/flex-layout';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatListModule} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {NotificationWizardComponent} from './notification-wizard-dialog.component';
import {NotificationWizardCanalComponent} from './notification-wizard-canal/notification-wizard-canal.component';
import {MatIconModule} from '@angular/material/icon';

import {
    NotificationWizardFilterComponent
} from './notification-wizard-filter/notification-wizard-filter.component';
import {NotificationWizardSummaryComponent} from './notification-wizard-summary/notification-wizard-summary.component';
import {NotificationWizardTextComponent} from './notification-wizard-text/notification-wizard-text.component';
import {MatTableModule} from '@angular/material/table';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE, OWL_DATE_TIME_FORMATS, OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';

export class CzechOwlDateTimeIntl extends OwlDateTimeIntl {
    cancelBtnLabel = 'Zrušit';
    setBtnLabel = 'Potvrdit';
    clearBtnLabel = 'Vymazat';
    closeBtnLabel = 'Zavřít';
    todayBtnLabel = 'Dnes';
    nowBtnLabel = 'Nyní';
    amBtnLabel = 'AM';
    pmBtnLabel = 'PM';
    upSecondLabel = 'Přidat sekundu';
    downSecondLabel = 'Odebrat sekundu';
    upMinuteLabel = 'Přidat minutu';
    downMinuteLabel = 'Odebrat minutu';
    upHourLabel = 'Přidat hodinu';
    downHourLabel = 'Odebrat hodinu';
    prevMonthLabel = 'Předchozí měsíc';
    nextMonthLabel = 'Další měsíc';
    prevYearLabel = 'Předchozí rok';
    nextYearLabel = 'Další rok';
    prevMultiYearLabel = 'Předchozích 21 let';
    nextMultiYearLabel = 'Dalších 21 let';
    switchToMonthViewLabel = 'Přepnout na zobrazení měsíce';
    switchToMultiYearViewLabel = 'Vybrat měsíc a rok';
    switchToDayViewLabel = 'Přepnout na zobrazení dne';
    switchToHourViewLabel = 'Přepnout na zobrazení hodin';
    switchToMinuteViewLabel = 'Přepnout na zobrazení minut';
    switchToSecondViewLabel = 'Přepnout na zobrazení sekund';
}
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {CdkDrag, CdkDropList} from '@angular/cdk/drag-drop';
import {RouterLink} from '@angular/router';
import {MatTooltipModule} from '@angular/material/tooltip';
import { AngularEditorModule } from '@wfpena/angular-wysiwyg';
import { NgSelectModule } from '@ng-select/ng-select';
import { TextEditorModule } from '../text-editor/text-editor.module';
import { AgGridPaginatorComponent } from '../ag-grid-paginator/ag-grid-paginator.component';

@NgModule({
    declarations: [
        NotificationWizardComponent,
        NotificationWizardCanalComponent,
        NotificationWizardFilterComponent,
        NotificationWizardSummaryComponent,
        NotificationWizardTextComponent,
    ],
    exports: [NotificationWizardComponent],
    imports: [
        CommonModule,
        SharedModule,
        MatButtonModule,
        TranslateModule,
        MatCheckboxModule,
        ExtendedModule,
        MatFormFieldModule,
        MatListModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        MatDialogModule,
        MatInputModule,
        MatIconModule,
        MatTableModule,
        MatDatepickerModule,
        MatMomentDateModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        OwlMomentDateTimeModule,
        FormsModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        CdkDrag,
        CdkDropList,
        RouterLink,
        MatTooltipModule,
        AngularEditorModule,
        NgSelectModule,
        TextEditorModule,
        AgGridPaginatorComponent,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'cs-CZ' },
        { provide: OWL_DATE_TIME_LOCALE, useValue: 'cs-CZ' },
        { provide: OwlDateTimeIntl, useClass: CzechOwlDateTimeIntl },
        {
            provide: OWL_DATE_TIME_FORMATS,
            useValue: {
                parseInput: 'DD. M. YYYY HH:mm',
                fullPickerInput: 'DD. M. YYYY HH:mm',
                datePickerInput: 'DD. M. YYYY',
                timePickerInput: 'HH:mm',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'D. M. YYYY',
                monthYearA11yLabel: 'MMMM YYYY',
            }
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'DD. M. YYYY HH:mm',
                },
                display: {
                    dateInput: 'D. M. YYYY',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'D. M. YYYY',
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            },
        },
    ],
})
export class NotificationWizardDialogModule {}
